<template>
  <!-- name: '个人中心' -->
  <div class="userCenterWrap">
    <div
      class="bgBox"
      @click="
        $router.push({
          path: '/userInfo',
          query: { title: '个人中心' },
        })
      "
    >
      <img :src="obj.headImage" alt="" v-default-img="defaultImgUrl" />
      <div class="infoBox">
        <span class="nameClass">{{ obj.nickName }}</span>
        <span class="accountClass">{{ obj.mobile }}</span>
      </div>
      <img
        src="https://img.bbalt.cn/imgh5/icon_arrow.svg"
        alt=""
        class="arrowIcon"
      />
    </div>
    <div class="valueBox">
      <div class="valueClass">
        <span>{{ obj.donateIntegral }}</span>
        公益捐赠积分
      </div>
      <div
        class="valueClass"
        @click="
          $router.push({
            path: '/other',
            query: { title: '减碳值' },
          })
        "
      >
        <span>{{ obj.totalCarbonReduction }}</span>
        累计减碳值
      </div>
    </div>
    <ul class="btnBox">
      <li @click="handleMyDonate()">
        <img
          src="https://img.bbalt.cn/imgh5/userCenter/icon_donateRecord.svg"
          alt=""
        />
        捐赠记录
      </li>
      <li
        @click="
          $router.push({
            path: '/userCenterSecond',
            query: { title: '可捐衣物登记' },
          })
        "
      >
        <img
          src="https://img.bbalt.cn/imgh5/userCenter/icon_register.svg"
          alt=""
        />
        可捐衣物登记
      </li>
      <!-- <li>
        <img src="https://img.bbalt.cn/imgh5/userCenter/icon_company.svg" alt="" />
        团体合作记录
      </li> -->
      <!-- <li>
        <img src="https://img.bbalt.cn/imgh5/userCenter/icon_applyRecord.svg" alt="" />
        申领记录
      </li> -->
      <li
        @click="
          $router.push({
            path: '/other',
            query: { title: '捐赠/申领须知' },
          })
        "
      >
        <img
          src="https://img.bbalt.cn/imgh5/userCenter/icon_notice.svg"
          alt=""
        />
        捐赠/申领须知
      </li>
      <li
        @click="$router.push({ path: '/other', query: { title: '支持我们' } })"
      >
        <img
          src="https://img.bbalt.cn/imgh5/userCenter/icon_volunteer.svg"
          alt=""
        />
        成为志愿者
      </li>
      <li
        @click="
          $router.push({ path: '/other', query: { title: '志愿者服务记录' } })
        "
      >
        <img
          src="https://img.bbalt.cn/imgh5/userCenter/icon_serviceRecord.svg"
          alt=""
        />
        志愿者服务记录
      </li>
      <li
        @click="$router.push({ path: '/other', query: { title: '关于我们' } })"
      >
        <img
          src="https://img.bbalt.cn/imgh5/userCenter/icon_aboutUs.svg"
          alt=""
        />
        关于我们
      </li>
      <li
        @click="$router.push({ path: '/other', query: { title: '支持我们' } })"
      >
        <img
          src="https://img.bbalt.cn/imgh5/userCenter/icon_contribution.svg"
          alt=""
        />
        捐款支持
      </li>
    </ul>
  </div>
</template>

<script>
import { userInfo } from "@/api/userCenter";
export default {
  components: {},
  data() {
    return {
      obj: {},
      defaultImgUrl: `https://img.bbalt.cn/imgh5/user_default.svg`,
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    async getUserInfo() {
      const { content } = await userInfo();
      this.obj = content;
      this.obj.donateIntegral = content.donateIntegral
        ? content.donateIntegral
        : 0;
      this.obj.totalCarbonReduction = content.totalCarbonReduction
        ? content.totalCarbonReduction
        : 0;
    },
    handleMyDonate() {
      this.$router.push({
        path: "/donateSecond",
        query: { title: "我的捐赠" },
      });
      localStorage.setItem("curSelectTab", "捐衣");
    },
  },
};
</script>

<style lang="scss" scoped>
.userCenterWrap {
  height: calc(100% - 100px);
  width: 100%;
  overflow: auto;
  padding-bottom: 37px;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  flex-flow: column;

  .bgBox {
    background: url("https://img.bbalt.cn/imgh5/userCenter/bg.png");
    width: 100%;
    height: 320px;
    background-size: 100% 100%;
    display: flex;
    align-items: center;

    img {
      width: 104px;
      height: 104px;
      margin-left: 36px;
      border-radius: 50%;
    }

    .infoBox {
      display: flex;
      flex-flow: column;
      font-family: PingFangSC, PingFang SC;
      margin-left: 32px;

      .nameClass {
        font-size: 44px;
        font-weight: 600;
        color: #333333;
        line-height: 56px;
      }

      .accountClass {
        height: 36px;
        font-size: 28px;
        font-weight: 400;
        color: #666666;
        line-height: 36px;
      }
    }
    .arrowIcon {
      width: 36px;
      height: 36px;
      margin-left: 14px;
    }
  }

  .valueBox {
    width: 93%;
    height: 160px;
    background: #ffffff;
    border-radius: 16px;
    margin-top: -80px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .valueClass {
      display: flex;
      flex-flow: column;
      align-items: center;
      font-size: 24px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 32px;

      span {
        height: 46px;
        font-size: 36px;
        font-weight: 600;
        color: #333333;
        line-height: 46px;
        margin-bottom: 8px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        max-width: 250px;
      }
    }
  }

  .btnBox {
    display: flex;
    flex-wrap: wrap;
    width: 93%;
    height: 638px;
    background: #ffffff;
    border-radius: 16px;
    margin-top: 16px;
    padding: 0px 17px;
    align-content: space-evenly;

    li {
      display: flex;
      flex-flow: column;
      width: calc(100% / 3);
      justify-content: center;
      align-items: center;

      font-size: 28px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #333333;

      img {
        width: 72px;
        height: 72px;
        margin-bottom: 24px;
      }
    }
  }
}
</style>
